export const spacing = {
  xsm: '6px',
  sm: '10px',
  md: '24px',
  lg: '36px',
  xlg: '60px',
  big: '100px',
};
